const FLAG_MAP = {
  NL: '/assets/flags/netherlands.svg',
  DE: '/assets/flags/germany.svg',
  BE: '/assets/flags/belgium.svg',
  FR: '/assets/flags/france.svg',
  LU: '/assets/flags/luxembourg.svg',
};

const POSTAL_MASK_MAP = {
  31: { mask: '#### @@', placeholder: '1234 AB' },
  32: { mask: '####', placeholder: '1000' },
  49: { mask: '#####', placeholder: '10115' },
  33: { mask: '#####', placeholder: '75001' },
  352: { mask: '####', placeholder: '1009' },
};

const PHONE_MASK_MAP = {
  31: { maxLength: 9 },
  32: { maxLength: 9 },
  49: { maxLength: 11 },
  33: { maxLength: 9 },
  352: { maxLength: 9 },
};

const MOBILE_ERROR_KEY_MAP = {
  31: 'verifyProfile.mobile.formatNL',
  32: 'verifyProfile.mobile.formatBE',
  49: 'verifyProfile.mobile.formatDE',
  33: 'verifyProfile.mobile.formatFR',
  352: 'verifyProfile.mobile.formatLU',
};

const DEFAULT_POSTAL = { mask: '#### @@', placeholder: '1234 AB' };
const DEFAULT_PHONE = { maxLength: 9 };

export function enrichCountry(raw) {
  const prefix = raw.mobile_prefix;
  const postal = POSTAL_MASK_MAP[prefix] || DEFAULT_POSTAL;
  const phone = PHONE_MASK_MAP[prefix] || DEFAULT_PHONE;

  return {
    code: raw.code,
    name: raw.translated_name_nl,
    prefix: raw.mobile_prefix,
    flagImg: FLAG_MAP[raw.code] || '',
    validationRegexMobile: raw.validation_regex_mobile || '',
    validationRegexPostalCode: raw.validation_regex_postal_code || '',
    postalMask: postal.mask,
    postalPlaceholder: postal.placeholder,
    phoneMaxLength: phone.maxLength,
    mobileErrorKey:
      MOBILE_ERROR_KEY_MAP[prefix] ||
      'verifyProfile.mobile.invalidFormatMessage',
  };
}

export function enrichCountries(rawList) {
  return rawList.map(enrichCountry);
}

export function parseValidationRegex(regexString) {
  if (!regexString) return null;
  let pattern = regexString;
  let flags = '';

  if (pattern.startsWith('/')) {
    const lastSlash = pattern.lastIndexOf('/');
    flags = pattern.substring(lastSlash + 1);
    pattern = pattern.substring(1, lastSlash);
  }

  try {
    return new RegExp(pattern, flags);
  } catch {
    return null;
  }
}

export const FALLBACK_COUNTRIES = [
  {
    code: 'NL',
    name: 'Nederland',
    prefix: '31',
    flagImg: '/assets/flags/netherlands.svg',
    validationRegexMobile: '/^6[0-9]{8}$/i',
    validationRegexPostalCode: '/^[1-9][0-9]{3}\\s?[a-zA-Z]{2}$/i',
    postalMask: '#### @@',
    postalPlaceholder: '1234 AB',
    phoneMaxLength: 9,
    mobileErrorKey: 'verifyProfile.mobile.formatNL',
  },
  {
    code: 'DE',
    name: 'Duitsland',
    prefix: '49',
    flagImg: '/assets/flags/germany.svg',
    validationRegexMobile: '/^(15|16|17)[0-9]{8,9}$/i',
    validationRegexPostalCode: '/^[0-9]{5}$/i',
    postalMask: '#####',
    postalPlaceholder: '10115',
    phoneMaxLength: 11,
    mobileErrorKey: 'verifyProfile.mobile.formatDE',
  },
  {
    code: 'BE',
    name: 'België',
    prefix: '32',
    flagImg: '/assets/flags/belgium.svg',
    validationRegexMobile: '/^(456|46|47|48|49)[0-9]{6,7}$/i',
    validationRegexPostalCode: '/^[0-9]{4}$/i',
    postalMask: '####',
    postalPlaceholder: '1000',
    phoneMaxLength: 9,
    mobileErrorKey: 'verifyProfile.mobile.formatBE',
  },
  {
    code: 'FR',
    name: 'Frankrijk',
    prefix: '33',
    flagImg: '/assets/flags/france.svg',
    validationRegexMobile: '/^[67][0-9]{8}$/i',
    validationRegexPostalCode: '/^[0-9]{5}$/i',
    postalMask: '#####',
    postalPlaceholder: '75001',
    phoneMaxLength: 9,
    mobileErrorKey: 'verifyProfile.mobile.formatFR',
  },
  {
    code: 'LU',
    name: 'Luxemburg',
    prefix: '352',
    flagImg: '/assets/flags/luxembourg.svg',
    validationRegexMobile: '/^(621|628|661|668|691|698)[0-9]{6}$/i',
    validationRegexPostalCode: '/^[0-9]{4}$/i',
    postalMask: '####',
    postalPlaceholder: '1009',
    phoneMaxLength: 9,
    mobileErrorKey: 'verifyProfile.mobile.formatLU',
  },
];
